import Typography from '@mui/material/Typography';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import messages from './messages';

const styles = {
  disabled: {
    color: 'action.disabled',
  },
  fullPrice: {
    pr: 0.5,
  },
  fullPriceVat: {
    color: 'text.secondary',
  },
  price: {
    textAlign: {
      md: 'left',
      sm: 'right',
    },
  },
};

export interface IPriceProps {
  currency: string;
  fullPrice: number;
  fullPriceVat: number;
  isDisabled?: boolean;
  isVat?: boolean;
}

export function Price({ currency, fullPrice, fullPriceVat, isDisabled = false, isVat = false }: IPriceProps) {
  return (
    <>
      <Typography
        component="span"
        sx={{
          ...styles.fullPrice,
          ...(isDisabled && styles.disabled),
        }}
        variant="body2"
      >
        <FormattedNumber
          currency={currency}
          // eslint-disable-next-line react/style-prop-object
          style="currency"
          value={fullPrice}
        />
      </Typography>
      <Typography
        component="span"
        sx={{
          ...styles.fullPriceVat,
          ...(isDisabled && styles.disabled),
        }}
        variant="body2"
      >
        {isVat && (
          <FormattedMessage
            {...messages.Vat}
            values={{
              price: (
                <FormattedNumber
                  currency={currency}
                  // eslint-disable-next-line react/style-prop-object
                  style="currency"
                  value={fullPriceVat}
                />
              ),
            }}
          />
        )}
      </Typography>
    </>
  );
}
